import React from "react";
import { Award, Mic, GraduationCap, Trophy } from "lucide-react";

const events = [
  {
    text: "Speaker at the Annual Information Security Summit (AISS), India",
    year: "2025",
    icon: Mic,
  },
  {
    text: "Speaker at Qiskit Fall Fest — India, Mexico & Costa Rica",
    year: "2025",
    icon: Mic,
  },
  {
    text: "Creative Destruction Lab (CDL) — Quantum Program Graduate",
    year: "2025",
    icon: GraduationCap,
  },
  {
    text: "LinkedIn Quantum Top Voice",
    year: "2022–2024",
    icon: Trophy,
  },
  {
    text: "Speaker @ Q2B Paris",
    year: "2024",
    icon: Mic,
  },
  {
    text: "Pitch Challenge Participant @ Q2B Silicon Valley",
    year: "2023",
    icon: Award,
  },
  {
    text: "Speaker @ Mobile World Congress",
    year: "2023",
    icon: Mic,
  },
  {
    text: "Creative Destruction Lab (CDL) — Quantum Bootcamp Participant",
    year: "2022",
    icon: GraduationCap,
  },
  {
    text: "Speaker at Global Fintech Fest, India",
    year: "2022",
    icon: Mic,
  },
];

export default function EventsSection() {
  return (
    <section
      id="events"
      data-testid="events-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section label */}
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#34D399]/80 mb-4 block">
          // Events, Awards & Recognition
        </span>

        <h2
          data-testid="events-heading"
          className="text-3xl md:text-5xl font-semibold tracking-tight text-[#F0FDF4] mb-4"
        >
          Global Presence
        </h2>
        <p className="text-base md:text-lg text-[#94A3B8] max-w-2xl mb-16 leading-relaxed">
          Recognized thought leader in quantum computing with speaking engagements
          and awards across three continents.
        </p>

        {/* Events timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-[#1A2F2A] hidden md:block" />

          <div className="space-y-0">
            {events.map((event, index) => (
              <div
                key={index}
                data-testid={`event-${index}`}
                className="flex items-start gap-5 py-4 group"
              >
                {/* Icon dot */}
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#1A2F2A]/60 border border-[#34D399]/20 flex items-center justify-center group-hover:bg-[#34D399]/20 group-hover:border-[#34D399]/40 transition-all z-10">
                  <event.icon size={16} className="text-[#34D399]" />
                </div>

                {/* Content */}
                <div className="flex-grow flex flex-col md:flex-row md:items-center md:justify-between gap-1 md:gap-4 border-b border-[#1A2F2A]/40 pb-4">
                  <p className="text-[#F0FDF4] text-sm md:text-base">
                    {event.text}
                  </p>
                  <span className="text-[#94A3B8] font-mono text-xs flex-shrink-0">
                    {event.year}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
